import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Area } from 'graphqlAPI'
import { prefix } from '../constants'
import { CoursesProgress } from '../components'

export function useColumns() {
  const { t } = useTranslation()
  type Column = {
    title: string
    key: keyof Area | 'courses_advance_finish' | 'action'
    sorteable?: boolean
    width?: number
    hideable?: boolean
    render?: (...data: any) => any
  }

  const prefixHeaders = `${prefix}.headers`
  const prefixColumns = `${prefix}.columns`

  const columns: Column[] = useMemo(
    () => [
      {
        title: t(`${prefixHeaders}.area`),
        key: 'name',
        sorteable: true,
        hideable: false,
        width: 70,
        render: (name) => {
          return (
            <div>
              {name} <span style={{ color: '#aaa9a9' }}></span>
            </div>
          )
        },
      },
      {
        title: t(`${prefixHeaders}.totalParticipants`),
        key: 'participantsCount',
        width: 170,
        sorteable: true,
        render: (value) => (
          <span>{t(`${prefixColumns}.participants`, { count: value })}</span>
        ),
      },
      {
        title: t(`${prefixHeaders}.courses`),
        key: 'coursesCount',
        width: 150,
        sorteable: true,
        render: (value) => (
          <span>{t(`${prefixColumns}.courses`, { count: value })}</span>
        ),
      },
      {
        title: t(`${prefixHeaders}.progress`),
        key: 'courses_advance_finish',
        width: 120,
        sorteable: true,
        render: (_, { coursesProgress }: Area) => (
          <CoursesProgress progress={coursesProgress} />
        ),
      },
      {
        title: t(`${prefixHeaders}.hours`),
        key: 'hoursTotal',
        width: 140,
        sorteable: true,
        render: (data) => (
          <span>{t(`${prefixColumns}.hoursTotal`, { count: data })}</span>
        ),
      },
      {
        title: '',
        key: 'action',
        width: 100,
        hideable: false,
        render: () => <span />,
      },
    ],
    [prefixColumns, prefixHeaders, t]
  )
  return columns
}
